import { UPDATE_SEARCHDATA_GOIVAY } from "./actionTypes";

export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHDATA_GOIVAY,
  payload: data,
});

